import '../styles/globals.css'
import '../styles/wow.css'
import type { AppProps } from 'next/app'
import Head from 'next/head'

export default function App({ Component, pageProps }: AppProps) {
  return (
    <>
      <Head>
        <link rel="stylesheet" href="/fonts/fonts.css" />
      </Head>
      <Component {...pageProps} />
    </>
  )
}
